<template src="../templates/normal_fcont_201.html" />
<script>
import LabelFunMessage from '../components/LabelFunMessage'
import FuncSearchGalleryQR from '../components/FuncSearchGalleryQR'
import ReleaseDateForArticle from '../components/ReleaseDateForArticle'
import FuncSearchRecommendLink from '../components/FuncSearchRecommendLink'
import FuncSearchGalleryTop from '../components/FuncSearchGalleryTop'
import { Carousel,Slide } from 'uiv'
import { mapState } from "vuex";

export default {
  name: 'app',
  data() {
    return {
      articleId: '201',
      app_root: process.env.VUE_APP_ROOT
    };
  },
  components: {
    LabelFunMessage,Carousel,Slide,FuncSearchRecommendLink,
    FuncSearchGalleryQR,ReleaseDateForArticle,FuncSearchGalleryTop
  },
  computed: {
    ...mapState(["os"]),
    isPc: function () {
      return this.os == "ws" || this.os == "mi";
    },
  },
  methods: {
  },
  metaInfo() {
    return {
      title: this.$store.state.messages.messages['201-1'],
    meta: [
      { name: 'description', content: this.$store.state.messages.messages['201-3']}
    ]};

  }
};
</script>
<style scoped>
div.dp-title {
  text-align: center;
}

h3.dp-special {
  margin-top: 20px;
  font-size: 30px;
  font-weight: bold;
  position: relative;
  display: inline-block;
  padding: 0 55px;
}

h3.dp-special:before,
h3.dp-special:after {
  content: '';
  position: absolute;
  top: 50%;
  display: inline-block;
  width: 45px;
  height: 1px;
  background-color: black;
}

h3.dp-special:before {
  left: 0;
}

h3.dp-special:after {
  right: 0;
}

h4.kiyaku{
  margin-top: 1.5em;
}

.instagram_link_area1 {
  margin-top: 20px;
}

.instagram_link_area2 {
  margin-top: 20px; 
  font-size: 18px; 
  line-height: 1.33; 
  text-align: center;
}

.instagram_button {
  margin-top: 10px;
  max-width: 100%;
  white-space: normal;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.instagram_logo {
  width: 48px; 
  height: 48px; 
  margin: 14px 24px 14px 24px; 
}

.instagram_button span {
  margin-right: 24px;
}

.instagram_qr {
  width: 100px; 
  height: 100px; 
  margin: 14px 24px 14px 0px;
}

/* 他記事へのリンク */
.flex {
    display: flex;
    flex-wrap: wrap;
    align-items: stretch;
}

.flex::before{ 
    display: none;
}

.flex .col {
    padding-bottom: 20px;
}

.func-search-recommend-link, .thumbnail {
    height: 100%;
    margin-bottom: 0px;
}

@media screen and (max-width: 991px) {
  .instagram_link_area2 {
    font-size: 14px; 
  }

  .instagram_logo {
    width: 40px; 
    height: 40px; 
    margin: 10px 20px 10px 10px; 
  }
  
  .instagram_button span {
    font-size: 14px;
    margin-right: 5px;
  }
}

@media (max-width: 767px) {
    /* 他記事へのリンク */
  .flex .col {
    padding-top: 5px;
    padding-bottom: 5px;
    padding-left: 5px;
    padding-right: 5px;
  }
}

@media (max-width: 480px) {
  div.dp-special h4 {
    font-size: 21px;
  }

  h3.dp-special {
    margin-top: 30px;
    font-size: 30px;
  }

}
</style>

